/**
 * Opens the WordPress media library and executes a callback with the selected attachment(s).
 *
 * @param {Function} callback - The callback function to handle the selected attachment(s).
 * @param {Object} [options={}] - Options for the media library.
 * @param {Boolean} [options.multiple=false] - Whether to allow selecting multiple attachments.
 * @param {Array<String>} [options.fileTypes=[]] - Array of allowed file MIME types (e.g., ['image/jpeg', 'image/png']).
 * @throws {TypeError} Will throw an error if the callback is not a function.
 */
const openMediaLibrary = ( callback, { multiple = false, fileTypes = [] } = {} ) => {
	// Validate the callback parameter
	if ( callback == null || typeof callback !== 'function' ) {
		throw new TypeError( 'The callback provided must be a non-null function.' );
	}

	// Create the configuration object for the media frame
	const frameConfig = { multiple };

	// Add the library type only if fileTypes is not empty
	if ( fileTypes.length ) {
		frameConfig.library = { type: fileTypes };
	}

	// Create a media frame using the WordPress media library
	const frame = wp.media( frameConfig );

	// Set up an event listener for when an item is selected
	// The frame.on( 'select', ... ) syntax is part of Backbone.js, which is a dependency of the WordPress media library and not jQuery.
	frame.on( 'select', () => {
		// Get the selected attachment(s)
		const selection = frame.state().get( 'selection' );
		const attachment = multiple ? selection.toJSON() : selection.first().toJSON();

		// Execute the callback with the selected attachment(s)
		callback( attachment );
	} );

	// Open the media frame
	frame.open();
};

export default openMediaLibrary;
